import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
// components
import CardList from "../components/CardList";
import withUrlSortParam from "../components/withUrlSortParam";
// selectors
import { getCardsForGroupAndCity } from "../selectors";
const mapStateToProps = (state, ownProps) => ({
    cards: getCardsForGroupAndCity(state, ownProps)
});
const GroupMonumentsCityFilterCardList = withUrlSortParam(connect(mapStateToProps)(CardList));
export default GroupMonumentsCityFilterCardList;
